if (document.documentElement.lang.toLowerCase().split('-')[0] === 'de') {
(() => {
  'use strict';
  const tx=value=>globalThis.AsteriaGermanCopy?.text(value)??String(value??'');

  const collectionMedia = globalThis.AsteriaCollectionMedia || Object.freeze({});

  function textNode(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = tx(value);
    return node;
  }

  function initialize(root) {
    const engine = globalThis.AsteriaNumerology;
    const content = globalThis.AsteriaNumerologyContent;
    const routes = globalThis.AsteriaNumerologyRoutes;
    if (!engine || !content) return;
    const isTr = root.dataset.locale === 'tr';
    const isIt = root.dataset.locale === 'it';
    const isDe = root.dataset.locale === 'de';
    const italianStone = (v) => ({'Turuncu Akik':'Agata arancione','Mavi Akik':'Agata blu','Pembe Akik':'Agata rosa','Pembe Kuvars':'Quarzo rosa','Mavi Kuvars':'Quarzo blu','Kaplan Gözü':'Occhio di tigre','Kırmızı Jasper':'Diaspro rosso','Lav Taşı':'Pietra lavica','Jade / Yeşim':'Giada','İnci':'Perla','Sedef':'Madreperla','Kuvars':'Quarzo','Akik':'Agata','Ametist':'Ametista','Mercan':'Corallo','Oniks':'Onice','Hematit':'Ematite','Jasper':'Diaspro','Havlit':'Howlite','Apatit':'Apatite','Sodalit':'Sodalite','Lapis Lazuli':'Lapislazzuli','Turkuaz':'Turchese','Kehribar':'Ambra'}[v] || v);
    const form = root.querySelector('[data-ae-numerology-form]');
    const input = root.querySelector('[data-ae-birth-date]');
    const error = root.querySelector('[data-ae-error]');
    const panel = root.querySelector('[data-ae-result]');
    const number = root.querySelector('[data-ae-life-path]');
    const heading = root.querySelector('[data-ae-heading-number]');
    const intents = root.querySelector('[data-ae-primary-intents]');
    const birthday = root.querySelector('[data-ae-birthday-number]');
    const birthdayTheme = root.querySelector('[data-ae-birthday-theme]');
    const birthdayCopy = root.querySelector('[data-ae-birthday-copy]');
    const trace = root.querySelector('[data-ae-trace]');
    const details = root.querySelector('[data-ae-trace-details]');
    const symbolic = root.querySelector('[data-ae-symbolic-copy]');
    const commerce = root.querySelector('[data-ae-commerce]');
    const collectionsBlock = root.querySelector('[data-ae-collections-block]');
    const collectionGrid = root.querySelector('[data-ae-collection-grid]');
    const stonesBlock = root.querySelector('[data-ae-stones-block]');
    const stoneGrid = root.querySelector('[data-ae-stone-grid]');
    const stonesNumber = root.querySelector('[data-ae-stones-number]');
    const commerceStatus = root.querySelector('[data-ae-commerce-status]');
    const shareRoot = root.querySelector('[data-ae-result-share]');
    if (!form || !input || !panel) return;

    let renderToken = 0;
    const now = new Date();
    input.max = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
    const dayPart = root.querySelector('[data-ae-date-part="day"]');
    const monthPart = root.querySelector('[data-ae-date-part="month"]');
    const yearPart = root.querySelector('[data-ae-date-part="year"]');
    if (yearPart) {
      for (let year = now.getFullYear(); year >= 1900; year -= 1) {
        const option = document.createElement('option');
        option.value = String(year);
        option.textContent = tx(String(year));
        yearPart.append(option);
      }
    }
    function syncDate() {
      if (!dayPart || !monthPart || !yearPart) return;
      input.value = dayPart.value && monthPart.value && yearPart.value
        ? yearPart.value + '-' + monthPart.value.padStart(2, '0') + '-' + dayPart.value.padStart(2, '0') : '';
    }
    for (const part of [dayPart, monthPart, yearPart]) {
      part?.addEventListener('change', syncDate);
    }
    function focusDate() {
      (dayPart || input).focus();
    }

    function resetCommerce() {
      renderToken += 1;
      if (!commerce) return;
      commerce.hidden = true;
      if (collectionsBlock) collectionsBlock.hidden = true;
      if (stonesBlock) stonesBlock.hidden = true;
      const productsBlock = root.querySelector('[data-ae-products-block]');
      if (productsBlock) productsBlock.hidden = true;
      root.querySelector('[data-ae-num-products]')?.replaceChildren();
      if (collectionGrid) collectionGrid.replaceChildren();
      if (stoneGrid) stoneGrid.replaceChildren();
      if (commerceStatus) {
        commerceStatus.hidden = true;
        commerceStatus.textContent = tx('');
      }
    }

    function collectionUrl(handle) {
      const rootPath = globalThis.Shopify?.routes?.root || '/';
      const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
      return base + 'collections/' + encodeURIComponent(handle);
    }

    function stoneProfileUrl(handle) {
      const rootPath = globalThis.Shopify?.routes?.root || '/';
      const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
      return base + 'pages/' + encodeURIComponent(handle);
    }

    async function renderCommerce(lifePath, token) {
      if (!commerce || !routes || typeof routes.resolve !== 'function') return;
      const routeData = routes.resolve(lifePath);
      if (!routeData) return;

      if (stonesNumber) stonesNumber.textContent = String(lifePath);
      if (stoneGrid) {
        const stoneCards = routeData.stones.map((item) => {
          const profile = typeof routes.getStoneProfile === 'function' ? routes.getStoneProfile(item.stone) : null;
          const card = document.createElement('article');
          card.className = 'ae-num__stone-card';

          if (profile && profile.handle && profile.image) {
            const link = document.createElement('a');
            link.href = item.collection ? collectionUrl(item.collection) : stoneProfileUrl('contact');

            const image = document.createElement('img');
            image.className = 'ae-num__stone-image';
            image.src = profile.image;
            image.alt = tx(isTr ? profile.titleTr : (isIt ? italianStone(profile.titleTr) : profile.titleEn));
            image.loading = 'lazy';
            image.decoding = 'async';
            link.append(image);

            const body = document.createElement('span');
            body.className = 'ae-num__stone-body';
            body.append(textNode('span', 'ae-num__stone-name', isIt ? italianStone(item.stone) : item.stone));
            if (item.stone !== profile.titleTr) body.append(textNode('small', 'ae-num__stone-family', isTr ? 'Görsel: ' + profile.titleTr + ' ailesi' : (isIt ? 'Immagine: famiglia ' + italianStone(profile.titleTr) : 'Image: ' + profile.titleEn + ' family')));
            body.append(textNode('span', 'ae-num__stone-cta', item.collection ? (isTr ? 'Tasarımları keşfet →' : (isIt ? 'Scopri le creazioni →' : 'Explore designs →')) : (isTr ? 'Özel tasarım için iletişime geç →' : (isIt ? 'Contattaci per una creazione personalizzata →' : 'Contact us for a custom design →'))));
            link.append(body);
            card.append(link);
          } else {
            card.append(textNode('div', 'ae-num__stone-body ae-num__stone-body--static', item.stone));
          }

          if (item.mode === 'info_custom_order') {
            card.append(textNode('p', 'ae-num__stone-note ae-num__stone-custom', isTr
              ? 'Bu spesiyal taş ile size özel bir ürün isterseniz lütfen bizimle iletişime geçin.'
              : isIt ? 'Per una creazione personalizzata con questa pietra speciale, contattaci.' : 'If you would like a custom piece with this special stone, please contact us.'));
            const customLink = document.createElement('a');
            customLink.className = 'ae-num__stone-custom-link';
            customLink.href = stoneProfileUrl('contact');
            customLink.textContent = tx(isTr ? 'Özel Tasarım Talebi Oluştur →' : (isIt ? 'Richiedi una creazione personalizzata →' : 'Request a Custom Design →'));
            card.append(customLink);
          }
          return card;
        });
        stoneGrid.replaceChildren(...stoneCards);
      }
      if (stonesBlock) stonesBlock.hidden = false;
      commerce.hidden = false;

      if (!collectionGrid || !collectionsBlock || typeof routes.loadProducts !== 'function' || typeof routes.getCollections !== 'function') return;
      if (commerceStatus) {
        commerceStatus.textContent = tx(isTr ? 'Uygun aktif tasarımlar doğrulanıyor…' : (isIt ? 'Verifica delle creazioni disponibili…' : 'Checking eligible active designs…'));
        commerceStatus.hidden = false;
      }

      const products = await routes.loadProducts(lifePath, { limit: 4 });
      if (token !== renderToken) return;
      const supportedStones = new Set(products.flatMap((item) => item.stones));
      const cards = [];

      routes.getCollections(lifePath)
        .filter((item) => Array.isArray(item.stones) && item.stones.some((stone) => supportedStones.has(stone)))
        .slice(0, 4)
        .forEach((item) => {
          const card = document.createElement('article');
          card.className = 'ae-num__collection-card';
          const link = document.createElement('a');
          link.href = collectionUrl(item.handle);
          const mediaEntry = collectionMedia[item.handle];
          const mediaUrl = (mediaEntry && typeof mediaEntry === 'object' ? mediaEntry.image : mediaEntry) || item.image;
          if (mediaUrl) {
            const image = document.createElement('img');
            image.className = 'ae-num__collection-image';
            image.src = mediaUrl;
            image.alt = tx(isTr ? item.titleTr + ' Koleksiyonu' : (isIt ? 'Collezione ' + italianStone(item.titleTr) : item.titleEn + ' Collection'));
            image.loading = 'lazy';
            image.decoding = 'async';
            link.append(image);
          }
          const body = document.createElement('span');
          body.className = 'ae-num__collection-body';
          body.append(textNode('span', 'ae-num__collection-name', isTr ? item.titleTr + ' Koleksiyonu' : (isIt ? 'Collezione ' + italianStone(item.titleTr) : item.titleEn + ' Collection')));
          body.append(textNode('span', 'ae-num__collection-cta', isTr ? 'Koleksiyonu keşfet →' : (isIt ? 'Scopri la collezione →' : 'Explore the collection →')));
          link.append(body);
          card.append(link);
          cards.push(card);
        });

      collectionGrid.replaceChildren(...cards);
      const productsBlock = root.querySelector('[data-ae-products-block]');
      const productHost = root.querySelector('[data-ae-num-products]');
      if (productsBlock && productHost) {
        const productCards = products.slice(0,4).map(item => {
          const card = document.createElement('article');
          card.className = 'ae-gate-product';
          const link = document.createElement('a');
          link.href = item.url;
          const image = document.createElement('img');
          image.src = item.image.replace(/^(?:http:)?\/\//, 'https://');
          image.alt = tx(item.title);
          image.loading = 'lazy';
          image.decoding = 'async';
          const copy = document.createElement('span');
          copy.append(
            textNode('strong', '', item.title),
            textNode('small', 'ae-num__product-reason', isTr ? 'İçerdiği ' + item.stones.join(', ') + ' ile sayının temalarına eşlik eder.' : (isIt ? 'Le pietre ' + item.stones.map(italianStone).join(', ') + ' richiamano i temi del tuo numero.' : 'Its ' + item.stones.join(', ') + ' connect with the themes of your number.')),
            textNode('small', '', new Intl.NumberFormat(isTr ? 'tr-TR' : (isIt ? 'it-IT' : isDe ? 'de-DE' : 'en-US'), {style:'currency',currency:root.dataset.currency || 'TRY'}).format(item.priceMinor / 100)),
            textNode('em', '', isTr ? 'Ürünü gör →' : (isIt ? 'Scopri il gioiello →' : 'View design →'))
          );
          link.append(image, copy);
          card.append(link);
          return card;
        });
        productHost.replaceChildren(...productCards);
        productsBlock.hidden = productCards.length === 0;
      }
      collectionsBlock.hidden = cards.length === 0;
      if (commerceStatus) {
        commerceStatus.hidden = true;
        commerceStatus.textContent = tx('');
      }
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      syncDate();
      panel.hidden = true;
      details.open = false;
      error.hidden = true;
      if (shareRoot) {
        shareRoot.hidden = true;
        shareRoot.dataset.shareText = tx('');
        shareRoot.dataset.shareUrl = '';
        const shareStatus = shareRoot.querySelector('[data-ae-share-status]');
        if (shareStatus) shareStatus.textContent = '';
      }
      resetCommerce();
      if (!input.value) {
        error.textContent = tx(isTr ? 'Geçerli bir doğum tarihi seç.' : (isIt ? 'Inserisci una data di nascita valida.' : 'Select a valid birth date.'));
        error.hidden = false;
        focusDate();
        return;
      }
      try {
        const result = engine.calculate(input.value);
        const steps = result.calculationTrace;
        const profile = content.profiles[result.lifePath];
        const birthdayProfile = content.birthdays[result.birthdayNumber];
        if (!profile || !birthdayProfile) throw new Error('Missing profile copy');
        number.textContent = tx(String(result.lifePath));
        heading.textContent = tx(String(result.lifePath));
        const master = root.querySelector('[data-ae-master]');
        if (master) master.hidden = ![11, 22, 33].includes(result.lifePath);
        intents.textContent = tx((isTr ? profile.primaryIntentsTr : (isIt ? profile.primaryIntentsIt : profile.primaryIntentsEn)).join(' · '));
        birthday.textContent = tx(String(result.birthdayNumber));
        birthdayTheme.textContent = tx(isTr ? birthdayProfile.shortThemeTr : (isIt ? birthdayProfile.shortThemeIt : birthdayProfile.shortThemeEn));
        birthdayCopy.textContent = tx(isTr ? birthdayProfile.summaryTr : (isIt ? birthdayProfile.summaryIt : birthdayProfile.summaryEn));
        const pageCopy = globalThis.AsteriaNumerologyPageCopy?.[result.lifePath];
        symbolic.textContent = tx((isTr ? pageCopy?.detailTr : (isIt ? pageCopy?.detailIt : pageCopy?.detailEn)) || (isTr ? profile.summaryTr : (isIt ? profile.summaryIt : profile.summaryEn)));
        const daySteps = steps.dayReductionSteps.length > 1 ? ' (' + steps.dayReductionSteps.join(' → ') + ')' : '';
        const yearSteps = steps.yearReductionSteps.length > 1 ? ' (' + steps.yearReductionSteps.join(' → ') + ')' : '';
        trace.textContent = tx(isIt
          ? 'Mese ' + steps.monthValue + '; giorno ' + steps.birthDayRaw + daySteps + '; anno ' + steps.birthYearRaw + ': ' + steps.yearDigitSum + yearSteps + '. ' + steps.monthValue + ' + ' + steps.dayValue + ' + ' + steps.yearValue + ' = ' + steps.rawTotal + ' → ' + result.lifePath + '.'
          : isTr
          ? 'Ay ' + steps.monthValue + '; gün ' + steps.birthDayRaw + daySteps + '; yıl ' + steps.birthYearRaw + ': ' + steps.yearDigitSum + yearSteps + '. ' + steps.monthValue + ' + ' + steps.dayValue + ' + ' + steps.yearValue + ' = ' + steps.rawTotal + ' → ' + result.lifePath + '.'
          : 'Month ' + steps.monthValue + '; day ' + steps.birthDayRaw + daySteps + '; year ' + steps.birthYearRaw + ': ' + steps.yearDigitSum + yearSteps + '. ' + steps.monthValue + ' + ' + steps.dayValue + ' + ' + steps.yearValue + ' = ' + steps.rawTotal + ' → ' + result.lifePath + '.');
        if (shareRoot && typeof engine.sharePayload === 'function') {
          const shareData = engine.sharePayload(result, isTr ? profile.primaryIntentsTr : (isIt ? profile.primaryIntentsIt : profile.primaryIntentsEn));
          const themeText = shareData.themes.join(' · ');
          shareRoot.dataset.shareText = tx(isTr
            ? 'Asteria Elite Numeroloji sonucum: Yaşam Yolu ' + shareData.lifePath + (themeText ? ' — ' + themeText : '')
            : isIt ? 'Il mio risultato di numerologia Asteria Elite: percorso di vita ' + shareData.lifePath + (themeText ? ' — ' + themeText : '') : 'My Asteria Elite Numerology result: Life Path ' + shareData.lifePath + (themeText ? ' — ' + themeText : ''));
          shareRoot.dataset.shareUrl = globalThis.location.href.split('#')[0];
          shareRoot.hidden = false;
        }
        panel.hidden = false;
        const token = renderToken;
        void renderCommerce(result.lifePath, token).catch(() => {
          if (token !== renderToken || !commerceStatus) return;
          commerceStatus.textContent = tx(isTr ? 'Tasarımlar şu anda yüklenemedi. Taş kartlarından keşfe devam edebilirsin.' : isIt ? 'Non è stato possibile caricare le creazioni. Puoi continuare a esplorare le pietre.' : 'Designs could not load right now. You can continue exploring through the stone cards.');
          commerceStatus.hidden = false;
        });
        const reduceMotion = globalThis.matchMedia && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panel.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'start' });
      } catch (_) {
        error.textContent = tx(isTr ? 'Geçerli bir doğum tarihi seç.' : (isIt ? 'Inserisci una data di nascita valida.' : 'Select a valid birth date.'));
        error.hidden = false;
        focusDate();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ae-numerology]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

} else {
(() => {
  'use strict';

  const collectionMedia = globalThis.AsteriaCollectionMedia || Object.freeze({});

  function textNode(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = value;
    return node;
  }

  function initialize(root) {
    const engine = globalThis.AsteriaNumerology;
    const content = globalThis.AsteriaNumerologyContent;
    const routes = globalThis.AsteriaNumerologyRoutes;
    if (!engine || !content) return;
    const isTr = root.dataset.locale === 'tr';
    const isIt = root.dataset.locale === 'it';
    const italianStone = (v) => ({'Turuncu Akik':'Agata arancione','Mavi Akik':'Agata blu','Pembe Akik':'Agata rosa','Pembe Kuvars':'Quarzo rosa','Mavi Kuvars':'Quarzo blu','Kaplan Gözü':'Occhio di tigre','Kırmızı Jasper':'Diaspro rosso','Lav Taşı':'Pietra lavica','Jade / Yeşim':'Giada','İnci':'Perla','Sedef':'Madreperla','Kuvars':'Quarzo','Akik':'Agata','Ametist':'Ametista','Mercan':'Corallo','Oniks':'Onice','Hematit':'Ematite','Jasper':'Diaspro','Havlit':'Howlite','Apatit':'Apatite','Sodalit':'Sodalite','Lapis Lazuli':'Lapislazzuli','Turkuaz':'Turchese','Kehribar':'Ambra'}[v] || v);
    const form = root.querySelector('[data-ae-numerology-form]');
    const input = root.querySelector('[data-ae-birth-date]');
    const error = root.querySelector('[data-ae-error]');
    const panel = root.querySelector('[data-ae-result]');
    const number = root.querySelector('[data-ae-life-path]');
    const heading = root.querySelector('[data-ae-heading-number]');
    const intents = root.querySelector('[data-ae-primary-intents]');
    const birthday = root.querySelector('[data-ae-birthday-number]');
    const birthdayTheme = root.querySelector('[data-ae-birthday-theme]');
    const birthdayCopy = root.querySelector('[data-ae-birthday-copy]');
    const trace = root.querySelector('[data-ae-trace]');
    const details = root.querySelector('[data-ae-trace-details]');
    const symbolic = root.querySelector('[data-ae-symbolic-copy]');
    const commerce = root.querySelector('[data-ae-commerce]');
    const collectionsBlock = root.querySelector('[data-ae-collections-block]');
    const collectionGrid = root.querySelector('[data-ae-collection-grid]');
    const stonesBlock = root.querySelector('[data-ae-stones-block]');
    const stoneGrid = root.querySelector('[data-ae-stone-grid]');
    const stonesNumber = root.querySelector('[data-ae-stones-number]');
    const commerceStatus = root.querySelector('[data-ae-commerce-status]');
    const shareRoot = root.querySelector('[data-ae-result-share]');
    if (!form || !input || !panel) return;

    let renderToken = 0;
    const now = new Date();
    input.max = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
    const dayPart = root.querySelector('[data-ae-date-part="day"]');
    const monthPart = root.querySelector('[data-ae-date-part="month"]');
    const yearPart = root.querySelector('[data-ae-date-part="year"]');
    if (yearPart) {
      for (let year = now.getFullYear(); year >= 1900; year -= 1) {
        const option = document.createElement('option');
        option.value = String(year);
        option.textContent = String(year);
        yearPart.append(option);
      }
    }
    function syncDate() {
      if (!dayPart || !monthPart || !yearPart) return;
      input.value = dayPart.value && monthPart.value && yearPart.value
        ? yearPart.value + '-' + monthPart.value.padStart(2, '0') + '-' + dayPart.value.padStart(2, '0') : '';
    }
    for (const part of [dayPart, monthPart, yearPart]) {
      part?.addEventListener('change', syncDate);
    }
    function focusDate() {
      (dayPart || input).focus();
    }

    function resetCommerce() {
      renderToken += 1;
      if (!commerce) return;
      commerce.hidden = true;
      if (collectionsBlock) collectionsBlock.hidden = true;
      if (stonesBlock) stonesBlock.hidden = true;
      const productsBlock = root.querySelector('[data-ae-products-block]');
      if (productsBlock) productsBlock.hidden = true;
      root.querySelector('[data-ae-num-products]')?.replaceChildren();
      if (collectionGrid) collectionGrid.replaceChildren();
      if (stoneGrid) stoneGrid.replaceChildren();
      if (commerceStatus) {
        commerceStatus.hidden = true;
        commerceStatus.textContent = '';
      }
    }

    function collectionUrl(handle) {
      const rootPath = globalThis.Shopify?.routes?.root || '/';
      const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
      return base + 'collections/' + encodeURIComponent(handle);
    }

    function stoneProfileUrl(handle) {
      const rootPath = globalThis.Shopify?.routes?.root || '/';
      const base = rootPath.endsWith('/') ? rootPath : rootPath + '/';
      return base + 'pages/' + encodeURIComponent(handle);
    }

    async function renderCommerce(lifePath, token) {
      if (!commerce || !routes || typeof routes.resolve !== 'function') return;
      const routeData = routes.resolve(lifePath);
      if (!routeData) return;

      if (stonesNumber) stonesNumber.textContent = String(lifePath);
      if (stoneGrid) {
        const stoneCards = routeData.stones.map((item) => {
          const profile = typeof routes.getStoneProfile === 'function' ? routes.getStoneProfile(item.stone) : null;
          const card = document.createElement('article');
          card.className = 'ae-num__stone-card';

          if (profile && profile.handle && profile.image) {
            const link = document.createElement('a');
            link.href = item.collection ? collectionUrl(item.collection) : stoneProfileUrl('contact');

            const image = document.createElement('img');
            image.className = 'ae-num__stone-image';
            image.src = profile.image;
            image.alt = isTr ? profile.titleTr : (isIt ? italianStone(profile.titleTr) : profile.titleEn);
            image.loading = 'lazy';
            image.decoding = 'async';
            link.append(image);

            const body = document.createElement('span');
            body.className = 'ae-num__stone-body';
            body.append(textNode('span', 'ae-num__stone-name', isIt ? italianStone(item.stone) : item.stone));
            if (item.stone !== profile.titleTr) body.append(textNode('small', 'ae-num__stone-family', isTr ? 'Görsel: ' + profile.titleTr + ' ailesi' : (isIt ? 'Immagine: famiglia ' + italianStone(profile.titleTr) : 'Image: ' + profile.titleEn + ' family')));
            body.append(textNode('span', 'ae-num__stone-cta', item.collection ? (isTr ? 'Tasarımları keşfet →' : (isIt ? 'Scopri le creazioni →' : 'Explore designs →')) : (isTr ? 'Özel tasarım için iletişime geç →' : (isIt ? 'Contattaci per una creazione personalizzata →' : 'Contact us for a custom design →'))));
            link.append(body);
            card.append(link);
          } else {
            card.append(textNode('div', 'ae-num__stone-body ae-num__stone-body--static', item.stone));
          }

          if (item.mode === 'info_custom_order') {
            card.append(textNode('p', 'ae-num__stone-note ae-num__stone-custom', isTr
              ? 'Bu spesiyal taş ile size özel bir ürün isterseniz lütfen bizimle iletişime geçin.'
              : isIt ? 'Per una creazione personalizzata con questa pietra speciale, contattaci.' : 'If you would like a custom piece with this special stone, please contact us.'));
            const customLink = document.createElement('a');
            customLink.className = 'ae-num__stone-custom-link';
            customLink.href = stoneProfileUrl('contact');
            customLink.textContent = isTr ? 'Özel Tasarım Talebi Oluştur →' : (isIt ? 'Richiedi una creazione personalizzata →' : 'Request a Custom Design →');
            card.append(customLink);
          }
          return card;
        });
        stoneGrid.replaceChildren(...stoneCards);
      }
      if (stonesBlock) stonesBlock.hidden = false;
      commerce.hidden = false;

      if (!collectionGrid || !collectionsBlock || typeof routes.loadProducts !== 'function' || typeof routes.getCollections !== 'function') return;
      if (commerceStatus) {
        commerceStatus.textContent = isTr ? 'Uygun aktif tasarımlar doğrulanıyor…' : (isIt ? 'Verifica delle creazioni disponibili…' : 'Checking eligible active designs…');
        commerceStatus.hidden = false;
      }

      const products = await routes.loadProducts(lifePath, { limit: 4 });
      if (token !== renderToken) return;
      const supportedStones = new Set(products.flatMap((item) => item.stones));
      const cards = [];

      routes.getCollections(lifePath)
        .filter((item) => Array.isArray(item.stones) && item.stones.some((stone) => supportedStones.has(stone)))
        .slice(0, 4)
        .forEach((item) => {
          const card = document.createElement('article');
          card.className = 'ae-num__collection-card';
          const link = document.createElement('a');
          link.href = collectionUrl(item.handle);
          const mediaEntry = collectionMedia[item.handle];
          const mediaUrl = (mediaEntry && typeof mediaEntry === 'object' ? mediaEntry.image : mediaEntry) || item.image;
          if (mediaUrl) {
            const image = document.createElement('img');
            image.className = 'ae-num__collection-image';
            image.src = mediaUrl;
            image.alt = isTr ? item.titleTr + ' Koleksiyonu' : (isIt ? 'Collezione ' + italianStone(item.titleTr) : item.titleEn + ' Collection');
            image.loading = 'lazy';
            image.decoding = 'async';
            link.append(image);
          }
          const body = document.createElement('span');
          body.className = 'ae-num__collection-body';
          body.append(textNode('span', 'ae-num__collection-name', isTr ? item.titleTr + ' Koleksiyonu' : (isIt ? 'Collezione ' + italianStone(item.titleTr) : item.titleEn + ' Collection')));
          body.append(textNode('span', 'ae-num__collection-cta', isTr ? 'Koleksiyonu keşfet →' : (isIt ? 'Scopri la collezione →' : 'Explore the collection →')));
          link.append(body);
          card.append(link);
          cards.push(card);
        });

      collectionGrid.replaceChildren(...cards);
      const productsBlock = root.querySelector('[data-ae-products-block]');
      const productHost = root.querySelector('[data-ae-num-products]');
      if (productsBlock && productHost) {
        const productCards = products.slice(0,4).map(item => {
          const card = document.createElement('article');
          card.className = 'ae-gate-product';
          const link = document.createElement('a');
          link.href = item.url;
          const image = document.createElement('img');
          image.src = item.image.replace(/^(?:http:)?\/\//, 'https://');
          image.alt = item.title;
          image.loading = 'lazy';
          image.decoding = 'async';
          const copy = document.createElement('span');
          copy.append(
            textNode('strong', '', item.title),
            textNode('small', 'ae-num__product-reason', isTr ? 'İçerdiği ' + item.stones.join(', ') + ' ile sayının temalarına eşlik eder.' : (isIt ? 'Le pietre ' + item.stones.map(italianStone).join(', ') + ' richiamano i temi del tuo numero.' : 'Its ' + item.stones.join(', ') + ' connect with the themes of your number.')),
            textNode('small', '', new Intl.NumberFormat(isTr ? 'tr-TR' : (isIt ? 'it-IT' : 'en-US'), {style:'currency',currency:root.dataset.currency || 'TRY'}).format(item.priceMinor / 100)),
            textNode('em', '', isTr ? 'Ürünü gör →' : (isIt ? 'Scopri il gioiello →' : 'View design →'))
          );
          link.append(image, copy);
          card.append(link);
          return card;
        });
        productHost.replaceChildren(...productCards);
        productsBlock.hidden = productCards.length === 0;
      }
      collectionsBlock.hidden = cards.length === 0;
      if (commerceStatus) {
        commerceStatus.hidden = true;
        commerceStatus.textContent = '';
      }
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      syncDate();
      panel.hidden = true;
      details.open = false;
      error.hidden = true;
      if (shareRoot) {
        shareRoot.hidden = true;
        shareRoot.dataset.shareText = '';
        shareRoot.dataset.shareUrl = '';
        const shareStatus = shareRoot.querySelector('[data-ae-share-status]');
        if (shareStatus) shareStatus.textContent = '';
      }
      resetCommerce();
      if (!input.value) {
        error.textContent = isTr ? 'Geçerli bir doğum tarihi seç.' : (isIt ? 'Inserisci una data di nascita valida.' : 'Select a valid birth date.');
        error.hidden = false;
        focusDate();
        return;
      }
      try {
        const result = engine.calculate(input.value);
        const steps = result.calculationTrace;
        const profile = content.profiles[result.lifePath];
        const birthdayProfile = content.birthdays[result.birthdayNumber];
        if (!profile || !birthdayProfile) throw new Error('Missing profile copy');
        number.textContent = String(result.lifePath);
        heading.textContent = String(result.lifePath);
        const master = root.querySelector('[data-ae-master]');
        if (master) master.hidden = ![11, 22, 33].includes(result.lifePath);
        intents.textContent = (isTr ? profile.primaryIntentsTr : (isIt ? profile.primaryIntentsIt : profile.primaryIntentsEn)).join(' · ');
        birthday.textContent = String(result.birthdayNumber);
        birthdayTheme.textContent = isTr ? birthdayProfile.shortThemeTr : (isIt ? birthdayProfile.shortThemeIt : birthdayProfile.shortThemeEn);
        birthdayCopy.textContent = isTr ? birthdayProfile.summaryTr : (isIt ? birthdayProfile.summaryIt : birthdayProfile.summaryEn);
        const pageCopy = globalThis.AsteriaNumerologyPageCopy?.[result.lifePath];
        symbolic.textContent = (isTr ? pageCopy?.detailTr : (isIt ? pageCopy?.detailIt : pageCopy?.detailEn)) || (isTr ? profile.summaryTr : (isIt ? profile.summaryIt : profile.summaryEn));
        const daySteps = steps.dayReductionSteps.length > 1 ? ' (' + steps.dayReductionSteps.join(' → ') + ')' : '';
        const yearSteps = steps.yearReductionSteps.length > 1 ? ' (' + steps.yearReductionSteps.join(' → ') + ')' : '';
        trace.textContent = isIt
          ? 'Mese ' + steps.monthValue + '; giorno ' + steps.birthDayRaw + daySteps + '; anno ' + steps.birthYearRaw + ': ' + steps.yearDigitSum + yearSteps + '. ' + steps.monthValue + ' + ' + steps.dayValue + ' + ' + steps.yearValue + ' = ' + steps.rawTotal + ' → ' + result.lifePath + '.'
          : isTr
          ? 'Ay ' + steps.monthValue + '; gün ' + steps.birthDayRaw + daySteps + '; yıl ' + steps.birthYearRaw + ': ' + steps.yearDigitSum + yearSteps + '. ' + steps.monthValue + ' + ' + steps.dayValue + ' + ' + steps.yearValue + ' = ' + steps.rawTotal + ' → ' + result.lifePath + '.'
          : 'Month ' + steps.monthValue + '; day ' + steps.birthDayRaw + daySteps + '; year ' + steps.birthYearRaw + ': ' + steps.yearDigitSum + yearSteps + '. ' + steps.monthValue + ' + ' + steps.dayValue + ' + ' + steps.yearValue + ' = ' + steps.rawTotal + ' → ' + result.lifePath + '.';
        if (shareRoot && typeof engine.sharePayload === 'function') {
          const shareData = engine.sharePayload(result, isTr ? profile.primaryIntentsTr : (isIt ? profile.primaryIntentsIt : profile.primaryIntentsEn));
          const themeText = shareData.themes.join(' · ');
          shareRoot.dataset.shareText = isTr
            ? 'Asteria Elite Numeroloji sonucum: Yaşam Yolu ' + shareData.lifePath + (themeText ? ' — ' + themeText : '')
            : isIt ? 'Il mio risultato di numerologia Asteria Elite: percorso di vita ' + shareData.lifePath + (themeText ? ' — ' + themeText : '') : 'My Asteria Elite Numerology result: Life Path ' + shareData.lifePath + (themeText ? ' — ' + themeText : '');
          shareRoot.dataset.shareUrl = globalThis.location.href.split('#')[0];
          shareRoot.hidden = false;
        }
        panel.hidden = false;
        const token = renderToken;
        void renderCommerce(result.lifePath, token).catch(() => {
          if (token !== renderToken || !commerceStatus) return;
          commerceStatus.textContent = isTr ? 'Tasarımlar şu anda yüklenemedi. Taş kartlarından keşfe devam edebilirsin.' : isIt ? 'Non è stato possibile caricare le creazioni. Puoi continuare a esplorare le pietre.' : 'Designs could not load right now. You can continue exploring through the stone cards.';
          commerceStatus.hidden = false;
        });
        const reduceMotion = globalThis.matchMedia && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches;
        panel.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'start' });
      } catch (_) {
        error.textContent = isTr ? 'Geçerli bir doğum tarihi seç.' : (isIt ? 'Inserisci una data di nascita valida.' : 'Select a valid birth date.');
        error.hidden = false;
        focusDate();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ae-numerology]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
}
